// Later to be moved in json localization file

export const campaignHeaderNames = {
	campaignObjective: 'Campaign objective',
	campaignSpendCap:  'Spend cap',
	fundingInstrument: 'Payment method',
};
export const groupHeaderNames = {
	groupName:                         'Name',
	groupBidStrategy:                  'Bid strategy',
	groupBidAmount:                    'Bid amount',
	groupGoal:                         'Budget type',
	groupOptimizationGoal:             'Conversion goal',
	groupGoalAmount:                   'Budget',
	groupStartTime:                    'Start',
	groupEndTime:                      'End',
	placements:                        'Placements',
	audienceType:                      'Audience type',
	communities:                       'Communities',
	gender:                            'Gender',
	communitiesExcluded:               'Communities excluded',
	interests:                         'Interests',
	keywords:                          'Keywords',
	customAudiences:                   'Custom audiences',
	customAudiencesExcluded:           'Custom audiences excluded',
	locations:                         'Locations',
	locationsExcluded:                 'Locations excluded',
	groupAppId:                        'App URL / ID',
	deviceType:                        'Device type',
	devices:                           'Devices',
	groupTargetingDevicesOSMinVersion: 'Min OS version',
	carriers:                          'Cell carriers',
};

export const adHeaderNames = {
	adPreview:                              'Preview',
	adName:                                 'Name',
	profileId:                              'Profile',
	creativeHeadline:                       'Headline',
	creativeType:                           'Post type',
	creativeText:                           'Content',
	creativeContentDestinationUrl:          'Destination URL',
	creativeContentDisplayUrl:              'Display URL',
	creativeContentMediaUrl:                'Image/Video',
	creativeThumbnailUrl:                   'Thumbnail image',
	creativeContentCaption:                 'Caption',
	creativeContentCallToAction:            'Call to action',
	creativeAllowComments: 	                'Allow comments',
	adClickEventTrackers:                   'Click event tracker(s)',
	adViewEventTrackers:                    'Impression event tracker(s)',
	adStartTime:                            'Start',
	adEndTime:                              'End',
	adTagline:                              'Tag line',
	adCallToActionLanguage:                 'Ad language',
	adCallToActionKey:                      'Call to action',
	adCallToActionClickthroughUrl:          'Clickthrough URL',
	adAsset:                                'Asset',
	adCompanionAsset:                       'Companion image',
	adLogoAsset:                            'Logo',
	adCanvasAsset:                          'Canvas',
	adThirdPartyTrackingMeasurementPartner: 'Measurement partner',
	adThirdPartyTrackingUrl:                'Third-party tracking URL',
	adAdvertiserName:                       'Advertiser name',
};
